import { extendTheme } from "@chakra-ui/react";

import colors from "./foundations/colors";
import radii from "./foundations/radii";
import shadows from "./foundations/shadows";
import { fonts, fontSizes, fontWeights, letterSpacings } from "./foundations/typography";
import semanticTokens from "./semanticTokens";
import button from "./components/button";
import badge from "./components/badge";
import card from "./components/card";
import modal from "./components/modal";
import menu from "./components/menu";
import popover from "./components/popover";
import drawer from "./components/drawer";
import skeleton from "./components/skeleton";
import progress from "./components/progress";
import { input, select, numberInput, textarea } from "./components/input";

const theme = extendTheme({
  config: {
    // Primeiro acesso segue o sistema; depois vale a escolha salva pelo alternador
    // (gerenciador padrão do Chakra, localStorage "chakra-ui-color-mode"). O script
    // equivalente em public/index.html aplica o tema antes do bundle carregar.
    initialColorMode: "system",
    useSystemColorMode: false,
  },
  colors,
  radii,
  shadows,
  fonts,
  fontSizes,
  fontWeights,
  letterSpacings,
  semanticTokens,
  components: {
    Button: button,
    Badge: badge,
    Card: card,
    Modal: modal,
    Menu: menu,
    Popover: popover,
    Drawer: drawer,
    Skeleton: skeleton,
    Progress: progress,
    Input: input,
    Select: select,
    NumberInput: numberInput,
    Textarea: textarea,
  },
  styles: {
    global: {
      body: {
        bg: "app-page",
        color: "app-fg",
      },
    },
  },
});

export default theme;
